export default [
  {
    path: "*",
    meta: {
      public: true,
    },
    redirect: {
      path: "/404",
    },
  },
  {
    path: "/404",
    meta: {
      public: true,
    },
    name: "NotFound",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/NotFound.vue`
      ),
  },
  {
    path: "/403",
    meta: {
      public: true,
    },
    name: "AccessDenied",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Deny.vue`
      ),
  },
  {
    path: "/500",
    meta: {
      public: true,
    },
    name: "ServerError",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Error.vue`
      ),
  },
  {
    path: "/login",
    meta: {
      public: true,
    },
    name: "Login",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Login.vue`
      ),
  },
  {
    path: "/",
    meta: { roleId: 1 },
    name: "Root",
    redirect: {
      name: "Dashboard",
    },
  },
  {
    path: "/profile",
    meta: {
      title: "Tài khoản",
      breadcrumb: true,
      requiresAuth: true,
      saveButton: true,
      roleId: 1,
    },
    name: "Profile",
    component: () => import(`@/views/Profile.vue`),
  },
  {
    path: "/tim-kiem-hinh-anh",
    meta: {
      title: "Tìm kiếm hình ảnh",
      breadcrumb: true,
      requiresAuth: true,
      roleId: 1,
    },
    name: "Dashboard",
    component: () =>
      import(
        /* webpackChunkName: "routes" */
        `@/views/Dashboard.vue`
      ),
  },
  {
    path: "/quan-ly-nhan-vien/",
    meta: {
      title: "Nhân viên",
      breadcrumb: true,
      requiresAuth: true,
      createButton: true,
      refreshButton: true,
      roleId: 1,
    },
    name: "StaffList",
    component: () => import(`@/views/Staff/list.vue`),
  },
  {
    path: "/quan-ly-nhan-vien/:Pid",
    meta: {
      title: "Nhân viên",
      breadcrumb: true,
      requiresAuth: true,
      saveButton: true,
      roleId: 1,
    },
    name: "StaffDetail",
    component: () => import(`@/views/Staff/detail.vue`),
  },
  {
    path: "/quan-ly-san-pham/",
    meta: {
      title: "Sản phẩm",
      breadcrumb: true,
      requiresAuth: true,
      createButton: true,
      refreshButton: true,
      otherButton: true, otherButtonText: "DS Người tạo", otherButtonIcon: "fa-user",
    },
    name: "ProductList",
    component: () => import(`@/views/Product/list.vue`),
  },
  {
    path: "/file-cham/",
    meta: {
      title: "File chậm",
      breadcrumb: true,
      requiresAuth: true,
      refreshButton: true,
      type: "slow_files",
    },
    name: "SlowFileList",
    component: () => import(`@/views/Product/list.vue`),
  },
  {
    path: "/file-ma-cu/",
    meta: {
      title: "File có mã cũ",
      breadcrumb: true,
      requiresAuth: true,
      refreshButton: true,
      type: "old_code_files",
    },
    name: "OldCodeFileList",
    component: () => import(`@/views/Product/list.vue`),
  },
  {
    path: "/quan-ly-san-pham/:Pid",
    meta: {
      title: "Sản phẩm",
      breadcrumb: true,
      requiresAuth: true,
      saveButton: true
    },
    name: "ProductDetail",
    component: () => import(`@/views/Product/detail.vue`),
  },
];
